import React, { FC } from 'react';
import {
  Headline,
  AdditionalItemDivider,
  DataWrapper,
  DataRow,
  DataRowHeader,
  DataRowContent, Wrapper, HeadlineWrapper, EditIconWrapper, EditIcon,
} from './AdditionalListContentUI';
import { AdditionalOperationListContentProps } from './AdditionalOperationListContent';
import { Link } from 'react-router-dom';
import { formatDate } from '../../utils/DateUtils';
import { ContentBox } from '../general/ContentBox';
import { Colors, OperationStateIcon } from '../../index';
import { FlexboxIcon } from '../general/Layout';
import styled from 'styled-components';
import { Headline6 } from '../general/Text';

const ErrorText = styled(Headline6)`
  font-size: 0.75rem;
  color: ${Colors.error};
  margin: 0 1.5rem 1.5rem;
`;

export const OperationContentWrapper = styled.div<{ isPreview?: boolean }>`
  ${Wrapper} {
    padding-top: 0;
    ${({ isPreview = false }) => isPreview ? `padding: 2rem 0 0 0;` : ''}
  }
  
  ${HeadlineWrapper} {
    padding: 0;
    ${({ isPreview = false }) => isPreview ? `padding: 0 2rem;` : ''}
  }
  
  ${ErrorText} {
    ${({ isPreview = false }) => isPreview ? `margin: 0 2rem;` : ''}
  }
  
  ${Headline} {
    min-height: 1.5rem;
    margin-bottom: 1rem;
  }
`;

export const OperationContent: FC<AdditionalOperationListContentProps> = (props) => {
  const { operation, users, customers, products, isPreview } = props;

  const findUser = (id: string) => {
    const user = users.find((user) => user.id === id) || null;
    let result = '';
    if (user) {
      result = `${user.firstName} ${user.familyName}`;
    } else {
      result = 'Benutzer nicht gefunden.';
    }

    return result;
  };

  const findCustomer = (id: string) => {
    const customer = customers.find((customer) => customer.id === id) || null;
    let result = '';
    if (customer) {
      result = customer.name;
    } else {
      result = 'Kunde nicht gefunden.';
    }

    return result;
  };

  const findProduct = (id: string) => {
    const product = products.find((product) => product.id === id) || null;
    let result = '';
    if (product) {
      result = product.name;
    } else {
      result = 'Produkt nicht gefunden.';
    }

    return result;
  };

  const editRoute = '/operations/{id}';

  const operationUpdatedAt = new Date(operation?.updatedAt);
  const daysRemaining = 365 - Math.floor((new Date().getTime() - operationUpdatedAt.getTime()) / (1000 * 60 * 60 * 24));

  return (
    <Wrapper>
      <HeadlineWrapper>
        <Headline>Allgemeine Informationen</Headline>
        {
          isPreview &&
          <EditIconWrapper>
            <Link to={editRoute.replace('{id}', operation.id)}>
              <EditIcon icon={'forwarding'} size={22} />
            </Link>
          </EditIconWrapper>
        }
      </HeadlineWrapper>
      {
        daysRemaining < 31 &&
        <ErrorText>Wird in { Math.max(0, daysRemaining) } Tagen gelöscht!</ErrorText>
      }
      <ContentBox>
        <DataWrapper>
          <DataRow>
            <DataRowHeader>Status:</DataRowHeader>
            <DataRowContent>
              <FlexboxIcon>
                <OperationStateIcon value={operation} textOnly />
                <OperationStateIcon value={operation} size={24} />
              </FlexboxIcon>
            </DataRowContent>
          </DataRow>
          <AdditionalItemDivider />
          <DataRow>
            <DataRowHeader>Kunde:</DataRowHeader>
            <DataRowContent>{findCustomer(operation.customerId)}</DataRowContent>
          </DataRow>
          <AdditionalItemDivider />
          <DataRow>
            <DataRowHeader>Berater:</DataRowHeader>
            <DataRowContent>{findUser(operation.userId)}</DataRowContent>
          </DataRow>
          <AdditionalItemDivider />
          <DataRow>
            <DataRowHeader>Beratungsdatum:</DataRowHeader>
            <DataRowContent>{formatDate(operation.createdAt)}</DataRowContent>
          </DataRow>
          <AdditionalItemDivider />
          <DataRow>
            <DataRowHeader>Letzte änderung:</DataRowHeader>
            <DataRowContent>{formatDate(operation.updatedAt)}</DataRowContent>
          </DataRow>
          <AdditionalItemDivider />
        </DataWrapper>
      </ContentBox>
    </Wrapper>
  );
};
